export default {
  DIRECTIVES: [],
  SERVICES: ['faceRecService', 'ledService']
}
